var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPanningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.429 7.038c-.395 0-.774.074-1.121.208V7.2c0-1.72-1.4-3.12-3.121-3.12h-.158c-.395 0-.773.073-1.122.207v-.165c0-1.72-1.4-3.121-3.2-3.121a3.126 3.126 0 0 0-3.112 2.879 3.125 3.125 0 0 0-4.27 2.906v13.412l-5.182-1.763a3.548 3.548 0 0 0-4.251 1.645 3.56 3.56 0 0 0 1.202 4.711l6.34 4.034a14.342 14.342 0 0 0 6.35 2.172c.03.003.062.004.092.004h7.044c4.208 0 7.63-3.423 7.63-7.63V10.16c0-1.722-1.4-3.122-3.121-3.122zM28.55 23.37A5.637 5.637 0 0 1 22.92 29h-6.997a12.324 12.324 0 0 1-5.415-1.863l-6.34-4.034a1.554 1.554 0 0 1-.525-2.057 1.548 1.548 0 0 1 1.856-.719l6.503 2.213a.998.998 0 0 0 1.322-.946V6.785c0-.618.503-1.12 1.14-1.12.619 0 1.122.502 1.122 1.12v8.343a1 1 0 1 0 2 0V4.12c0-.618.503-1.121 1.2-1.121.618 0 1.121.503 1.121 1.121V14.55a1 1 0 1 0 2 0V7.2c0-.619.503-1.122 1.122-1.122h.158c.618 0 1.12.503 1.12 1.121v7.41a1 1 0 1 0 2 0v-4.45a1.122 1.122 0 0 1 2.244 0V23.37z",
    fill: "#6e8192",
    className: "color000 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanningIcon);
export default __webpack_public_path__ + "static/media/panning-icon.898fed0b7c810fb83550905f6ba288ec.svg";
export { ForwardRef as ReactComponent };